import React, { useEffect, useState } from "react";
import "./Reports.css";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../components/SidebarQA/Sidebar";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { Link } from "react-router-dom";
import * as AiIcons from "react-icons/ai";
import * as FiIcons from "react-icons/fi";
import { DataLoader } from "../../utils/DataLoader";
import { ReportFilter } from "../../components/SearchFilter/ReportFilter";
import { GetQAAllReports } from "../../apis/ReportsAPI";
import { filterBy } from "@progress/kendo-data-query";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";

export default function Reports() {
  const {user} = useSelector((state) => state.auth);
  const [reportTypes, setReportTypes] = useState([]);
  const [allReport, setAllReport] = useState([]);

  const ControllerNActionName = {
    ControllerName: "Reports",
    ActionName: "getallorderreport",
    SearchField: "order_id",
    MandatoryField: "qa_id",
  };
  const [reports, setReports] = useState({
    data: [],
    total: 77,
  });
  const [dataState, setDataState] = useState({
    take: 50,
    skip: 0,
    filter: "0",
    mandatoryField: user.userid,
  });
  const dataStateChange = (e) => {
    setDataState(e.dataState);
  };
  const dataReceived = (orders) => {
    setReports(orders);
  };
  const initialSort = [
    {
      field: "order_id",
      dir: "desc",
    },
  ];
  const [count, setCount] = useState(1);
  const [sort, setSort] = React.useState(initialSort);

  const handleSorting = (e) => {
    localStorage.setItem("sortData", true);
    let sortingArray = e.sort;
    sortingArray.forEach((element, i) => {
      if (element.field === "orderId") {
        e.sort[i].field = "order_id";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "customerName") {
        e.sort[i].field = "order_customer_name";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "requestorName") {
        e.sort[i].field = "requestor_name";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "applicantName") {
        e.sort[i].field = "order_applicant_name";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "completionDate") {
        e.sort[i].field = "order_end_date";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      }
    });
    setCount(count + 1);
    setSort(e.sort);
  };
  const handleSearch = async (searchValue) => {
    localStorage.setItem("searchData", true);
    setDataState({
      take: 50,
      skip: 0,
      filter: searchValue,
      mandatoryField: user.userid,
    });
  };
  const handleAdvanceSearch = async (searchData) => {
    let completionSearch = false;
    if (
      searchData.completionStartDate !== "" &&
      searchData.completionEndDate !== ""
    )
      completionSearch = true;

    let searchBody = {
      isAdvanceSearch: "yes",
      completion_start_date:
        completionSearch === true
          ? dateFormat(searchData.completionStartDate, "yyyy-mm-dd")
          : "",
      completion_end_date:
        completionSearch === true
          ? dateFormat(searchData.completionEndDate, "yyyy-mm-dd")
          : "",
      order_applicant_name:
        searchData.applicantName == undefined ? "" : searchData.applicantName,
      report_id:
        searchData.reportType.report_id === 0
          ? ""
          : searchData.reportType.report_id + "",
    };
    localStorage.setItem("searchData", true);
    setDataState({
      take: 50,
      skip: 0,
      filter: searchBody,
      mandatoryField: user.userid,
    });
  };

  useEffect(() => {
    getReportList();
  }, []);

  const getReportList = async () => {
    var result = await GetQAAllReports(user.userid);
    setAllReport(result.data.slice());
    setReportTypes(result.data.slice());
  };

  const filterData = (filter) => {
    const data = allReport.slice();
    return filterBy(data, filter);
  };

  const reportFilterChange = (e) => {
    setReportTypes(filterData(e.filter));
  };
  //
  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="admin-page-row orders">
                  <Col lg={6} md={6} sm={12}>
                    <div className="page-title">
                      <h2>Reports</h2>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <div className="search-filter">
                      <ReportFilter
                        search={handleSearch}
                        advSearch={handleAdvanceSearch}
                        requestorid="0"
                        investigatorid={user.userid}
                        reportTypes={reportTypes}
                        reportFilterChange={reportFilterChange}
                        searchPlaceHolder="Search by order id"
                        displayShort={false}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Grid
                      sortable={true}
                      sort={sort}
                      onSortChange={(e) => {
                        handleSorting(e);
                      }}
                      pageable={true}
                      {...dataState}
                      className="report-table"
                      style={{ height: "70vh" }}
                      data={reports}
                      onDataStateChange={dataStateChange}
                      resizable={true}
                    >
                      <GridColumn
                        field="orderId"
                        title="Order No."
                        width="120px"
                        minResizableWidth={30}
                      />
                      <GridColumn
                        field="customerName"
                        title="Customer"
                        width="100%"
                        minResizableWidth={130}
                      />
                      <GridColumn
                        field="requestorName"
                        title="Requestor"
                        width="100%"
                        minResizableWidth={130}
                      />
                      <GridColumn
                        field="applicantName"
                        title="Applicant"
                        width="100%"
                        minResizableWidth={130}
                      />
                      <GridColumn
                        field="completionDate"
                        title="Completion Date"
                        width="100%"
                        minResizableWidth={130}
                      />
                      <GridColumn
                        field="id"
                        title="Action"
                        width="200px"
                        minResizableWidth={180}
                        cell={(props) =>
                          props.dataItem.isPrimary &&
                          !props.dataItem.templateName.includes(
                            "Pdf Reports"
                          ) ? (
                            <td className="act">
                              <Link
                                to={"/Report?type=view&id=" + props.dataItem.id}
                                target="_blank"
                              >
                                <AiIcons.AiOutlineEye />
                              </Link>{" "}
                              <Link
                                to={`/Report?type=view_download&id=${props.dataItem.id}&reportname=${props.dataItem.templateName}`}
                                target="_blank"
                              >
                                <FiIcons.FiDownload />
                              </Link>
                            </td>
                          ) : (
                            <td className="req"></td>
                          )
                        }
                      ></GridColumn>
                    </Grid>
                    <DataLoader
                      dataState={dataState}
                      onDataReceived={dataReceived}
                      dataItem={ControllerNActionName}
                      dataSort={sort}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
